import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import MuiRadioGroup from "Utils/Helpers/MuiRadioGroup";
import Inputer from "Utils/Helpers/Inputer";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import MButton from "Utils/Helpers/MButton";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setSocialData } from "../../../../../Redux/slices/mngrSlice";
import { put_social } from "http/components/Social";
import OpenSee from "../../../../../Utils/Assets/Images/opensee.svg";
import Rari from "../../../../../Utils/Assets/Images/Rari.svg";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditSocialData({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      label: "Name",
      type: "text",
      multiLine: false,
      placeholder: "Enter name",
      value: "",
      validation: false,
    },
    link: {
      label: "Link",
      type: "text",
      multiLine: false,
      placeholder: "Enter link",
      value: "",
      validation: false,
    },
    icon: {
      label: "Icon",
      type: "radio",
      value: "",
      items: [
        { key: <Icons.Whatsapp />, value: "Whatsapp" },
        { key: <Icons.Telegram />, value: "Telegram" },
        { key: <Icons.Instagram />, value: "Instagram" },
        { key: <Icons.Facebook />, value: "Facebook" },
        { key: <Icons.Discord />, value: "Discord" },
        { key: <Icons.Reddit />, value: "Reddit" },
        { key: <Icons.Medium />, value: "Medium" },
        { key: <Icons.Threads />, value: "Threads" },
        { key: <Icons.Youtube />, value: "Youtube" },
        { key: <Icons.TwitterX />, value: "TwitterX" },
        { key: <Icons.EnvelopePaper />, value: "Email" },
        { key: <img src={OpenSee} />, value: "OpenSee" },
        { key: <img src={Rari} />, value: "Rarible" },
      ],
    },
  });

  const onEnter = () => {
    const items = controls.icon.items;
    setControls({ name: { value: row.name, validation: true } });
    setControls({ icon: { value: items.find((i) => i.value === row.icon) } });
    setControls({ link: { value: row.link, validation: true } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onChangeRadio = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onSubmit = async () => {
    const { name, icon, link } = controls;
    if (name.validation && link.validation && icon.value) {
      dispatch(HandleLoading(true));
      const response = await put_social({
        id: row.id,
        name: name.value,
        link: link.value,
        icon: icon.value.value,
      });
      if (CheckApiStatus(response)) {
        dispatch(setSocialData(true));
        enqueueSnackbar("Edit Success", { variant: "success" });
      }
      setShow(false);
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Pencil size={16} />}
        label="Edit"
        onClick={setShowDialog}
        className="btn-manager btn-edit"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"xs"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-edit"
        >
          <DialogTitle>{`Edit (${row.name})`}</DialogTitle>
          <DialogContent>
            {show && (
              <Grid2 container spacing={2}>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid2 size={{ xs: 12 }} key={key + index}>
                      {controls[key].type === "text" && (
                        <Inputer
                          id={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          label={controls[key].label}
                          placeholder={controls[key].placeholder}
                          type={controls[key].type}
                          multiLine={controls[key].multiLine}
                        />
                      )}
                      {controls[key].type === "radio" && (
                        <MuiRadioGroup
                          name={key}
                          value={controls[key].value}
                          label={controls[key].label}
                          items={controls[key].items}
                          onChange={onChangeRadio}
                          classname="icon-items"
                        />
                      )}
                    </Grid2>
                  );
                })}
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Update"}
              className="flex-grow-1"
              onClick={onSubmit}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
